import { OrganizationCompactEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const AccountOrganizationResource = authResource({
    path: '/accounts/:accountId/organizations/:id',
    schema: OrganizationCompactEntity,
    searchParams: {}
}).extend('getList', {
    schema: paginatedSchema(OrganizationCompactEntity)
});
